import Vue from 'vue'
export default {
  interval: null,
  socket: {},
  socketUrl: 'wss://iself-retail.com/wss',
  // socketUrl: 'ws://192.168.1.6:2346',
  setWs: function (newWs) {
    this.socket = newWs
  },
  getSocket() {
    if (typeof (WebSocket) === 'undefined') {
      console.log('Your browser does not support WebSocket');
    } else {
      this.socket = new WebSocket(this.socketUrl);
      this.socket.onopen = () => {
        this.interval = setInterval(() => {
          if (this.socket.readyState != this.socket.OPEN) {
            location.reload()
          } else {
            this.send('Hello!');
          }
        }, 9000);
        this.send(JSON.stringify({
          "type": "user_connect",
          "user_id": 9999,
          "user_type": "2"
        }));
      };
      this.socket.onclose = () => {
        console.log('Socket closed')
      }
    }
  },
  getonmessage() {
    this.socket.onmessage = (msg) => {
      // 发现消息进入, 开始处理前端触发逻辑
      var data = JSON.parse(msg.data)
      if (data.type == 'success_send') {
        Vue.prototype.$message({
          type: 'success',
          message: 'Get All Message Success'
        })
      }
      if (data.type == 'faild_send') {
        Vue.prototype.$message.error('Get All Message Faild')
      }
      if (data.type == 'socket_close' && data.close_user.length != 0) {
        Vue.prototype.$message.error(`${data.close_user} offline`)
      }
      if (data.type == 'socket_connect' && data.connect_user.length != 0) {
        Vue.prototype.$message({
          type: 'success',
          message: `${data.connect_user} online`
        })
      }
    };
  },
  onclose() {
    clearInterval(this.interval);
    this.interval = null
    this.socket.close()
  },
  onerror() {
    this.socket.onerror = () => {
      this.getSocket()
      // 此时可以尝试刷新页面
    };
  },
  send(msg) {
    this.socket.send(msg)
  },
}



// WEBPACK FOOTER //
// ./src/utils/global.js